export const BACKGROUND_COLORS = {
  DANGER_DARK: '#b8000e',
  DANGER_LIGHT: '#ffbdb6',
  DANGER_LIGHTER: '#ffdad5',
  DANGER_LIGHTEST: '#ffece9',
  DANGER: '#dc1f30',
  GREY_LIGHTER: '#f7f4f2',
  GREY_LIGHTEST: '#f7f4f2',
  GREY: '#ebe7e4',
  MODAL_BACKGROUND: '#000000b3',
  PINK_LIGHT: '#ffd4e1',
  PINK_LIGHTER: '#ffe5ed',
  PINK_LIGHTEST: '#ffe5ed',
  PRIMARY_DARK: '#004d40',
  PRIMARY_LIGHT: '#c5e4d8',
  PRIMARY_LIGHTER: '#deeee8',
  PRIMARY_LIGHTEST: '#f0f5f4',
  PRIMARY: '#216e54',
  PROGRESS_BAR_INCOMPLETE: '#deeee8',
  PROGRESS_BAR_COMPLETE: '#c5e4d8',
  SECONDARY_LIGHT: '#c5e4d8',
  SECONDARY_LIGHTER: '#deeee8',
  SECONDARY_LIGHTEST: '#f0f5f4',
  SECONDARY: '#216e54',
  SUCCESS_LIGHT: '#92ee96',
  SUCCESS_LIGHTER: '#b6fdb7',
  SUCCESS_LIGHTEST: '#cfffcf',
  SUCCESS: '#049404',
  TERTIARY_LIGHT: '#acff99',
  TERTIARY_LIGHTER: '#ceffc2',
  TERTIARY_LIGHTEST: '#e1ffda',
  TRANSPARENT: 'transparent',
  WARNING_LIGHT: '#f7d064',
  WARNING_LIGHTER: '#ffe289',
  WARNING_LIGHTEST: '#fff2b9',
  WARNING: '#ebac00',
  WHITE: '#ffffff',
} as const;
